import { motion } from "framer-motion";

const TransitionalDivider = () => {
  return (
    <div className="relative w-full flex items-center justify-center py-3 px-6 bg-transparent overflow-hidden">
      <motion.div
        className="flex items-center gap-4 w-full max-w-2xl"
        initial={{ opacity: 0, scaleX: 0.4 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true, margin: "-5%" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className="flex-1 h-px bg-gradient-to-r from-transparent via-[#C2A04A]/60 to-[#C2A04A]/30" />
        <span className="text-[#C2A04A] text-[10px] tracking-[0.35em] uppercase font-body font-medium opacity-70 select-none whitespace-nowrap">
          ✦
        </span>
        <span className="flex-1 h-px bg-gradient-to-l from-transparent via-[#C2A04A]/60 to-[#C2A04A]/30" />
      </motion.div>
    </div>
  );
};

export default TransitionalDivider;
